import { jsx } from 'panel';
import { ButtonEl } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
import { UpsellModalEl } from 'common/widgets/upsell-modal';
export function template() {
  return jsx("div", {
    sel: '.oda-control'
  }, jsx("div", {
    sel: '.footer'
  }, jsx(ButtonEl, {
    sel: '.analyze-btn',
    attrs: {
      disabled: this.attr("is-waiting-for-schedule-analysis"),
      icon: this.attr("is-waiting-for-schedule-analysis") ? "spinner" : "segment",
      theme: ButtonTheme.Secondary
    },
    on: {
      click: this.attr("show-upsell") ? this.helpers.handleClickUpsell : this.helpers.handleClickAnalyze
    }
  }, this.attr("show-upsell") ? "Upgrade to Find Interesting Segments" : "Find Interesting Segments"), jsx("div", {
    sel: '.analyze-description'
  }, this.attr("description"))), this.state.isUpsellModalOpen ? jsx(UpsellModalEl, {
    attrs: {
      closeable: true,
      description: this.attr("upsell-description"),
      'feature-gate-type': "oda",
      header: "Find statistically significant segments",
      'learn-more-url': "https://help.mixpanel.com/hc/en-us/articles/360031788492-Find-Interesting-Segments",
      open: true
    },
    on: {
      change: this.helpers.handleChangeUpsellModal
    }
  }) : null);
}